import { render, staticRenderFns } from "./DocumentGroups.vue?vue&type=template&id=1a95057f"
import script from "./DocumentGroups.vue?vue&type=script&lang=js"
export * from "./DocumentGroups.vue?vue&type=script&lang=js"
import style0 from "./DocumentGroups.vue?vue&type=style&index=0&id=1a95057f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports